export default __webpack_public_path__ + "static/nl-f710135d1f8bc39ae7473d8e3f6c9606.svg";